import React, { useState } from "react";
import { Chart } from "primereact/chart";

export const DoughnutChartDemo = (props) => {
  let total = props.right + props.wrong + props.skipped;
  // console.log(props.right, props.wrong);
  const [chartData] = useState({
    // labels: ['الصحيحة', 'الخاطئة','تخطي'],
    datasets: [
      {
        data: [props.right, props.wrong, props.skipped],
        backgroundColor: ["#57C1A1", "#FF627F", "rgb(159, 159, 159)"],
        hoverBackgroundColor: ["#57C1A1", "#FF627F", "rgb(159, 159, 159)"],
      },
    ],
  });

  const [lightOptions] = useState({
    plugins: {
      legend: {
        labels: {
          color: "#495057",
        },
      },
    },
  });
  return (
    <div style={{ position: "relative" }} className="doughnut-container">
      <Chart
        type="doughnut"
        data={chartData}
        options={lightOptions}
        style={{
          textAlign: "center",
          width: "200px",
          height: "200px",
          // position: "absolute",
          top: "0",
          // left: "24px",
          left: "0",
          // right: "0",
          margin: "0 auto",
        }}
      />
      <h3 className="titleOfChart">
        {((props.right / total) * 100).toFixed(2)}%
      </h3>
      {window.innerWidth < 768 ? (
        <>
          <p> الاجابات الصحيحة {props.right}</p>
          <p>الاجابات الخطأ {props.wrong + props.skipped}</p>
        </>
      ) : (
        ""
      )}
    </div>
  );
};
